import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DataTableCardModel } from '@components/data-table-card/data-table-card.model';
import { HighlightConfig } from '@models/highlight-config.model';

@Component({
  selector: 'app-data-table-card',
  templateUrl: './data-table-card.component.html',
  styleUrls: ['./data-table-card.component.scss']
})
export class DataTableCardComponent {
  @Input() record: DataTableCardModel;
  @Input() style;
  @Input() isActionDisabled = false;
  @Input() isLoading = false;
  @Input() highlightConfig: HighlightConfig;
  @Input() hasAvatar = true;

  @HostBinding('class.horizontal') @Input() horizontal = false;
  @HostBinding('class.hidden') @Input() hidden = false;

  @Output() action = new EventEmitter<any>();
  @Output() clicked = new EventEmitter<any>();

  currentLang = 'ro';

  constructor(private translateService: TranslateService) {
    this.currentLang = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLang = event.lang;
    });
  }

  @HostListener('click', ['$event'])
  onClick(event: any) {
    this.clicked.emit(this.record);
    if (event) {
      event.stopPropagation();
      return false;
    }
  }

  cardAction(action) {
    this.action.emit(action);
  }

  hide() {
    this.hidden = true;
  }

  show() {
    this.hidden = false;
  }

  shouldHighlightRow(row: any): boolean {
    return this.highlightConfig && row[this.highlightConfig.column] === this.highlightConfig.value;
  }

  get highlightColor(): string {
    return this.highlightConfig?.color;
  }

  onAction(action: any) {
    this.action.emit({action});
  }
}
